"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roleModulesSchema = exports.assignPermissionToRoleSchema = exports.updateRoleSchema = exports.createRoleSchema = exports.roleShape = void 0;
const zod_1 = require("zod");
const module_codes_1 = require("../navigation/module-codes");
exports.roleShape = {
    name: zod_1.z.string().min(1).max(100),
    description: zod_1.z.string().max(500).optional(),
    parentRoleId: zod_1.z.string().uuid().optional(),
};
exports.createRoleSchema = zod_1.z.object(exports.roleShape);
exports.updateRoleSchema = exports.createRoleSchema.partial();
exports.assignPermissionToRoleSchema = zod_1.z.object({
    permissionIds: zod_1.z.array(zod_1.z.string().uuid()).min(1),
});
/** Replaces a role's entire sidebar-module grant set (see `RoleModule`) in one call — unlike the per-checkbox permission-assign endpoint above, there's no incremental-audit need across just 16 possible values. */
exports.roleModulesSchema = zod_1.z.object({
    moduleCodes: zod_1.z.array(zod_1.z.enum(module_codes_1.NAV_MODULE_CODES)),
});
//# sourceMappingURL=role.schema.js.map